<template>
  <div class="DhCtaComponent">
    <chevron-section colorHex="#fe5000" top>
      <wrapper-responsive-center>
        <div class="white--text">
          <slot></slot>
        </div>
      </wrapper-responsive-center>
    </chevron-section>
  </div>
</template>

<script>
  import ChevronSection from '../structure/ChevronSection'
  import WrapperResponsiveCenter from '../structure/WrapperResponsiveCenter'

  export default {
    name: 'DhCta',
    components: { WrapperResponsiveCenter, ChevronSection },
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {},
    watch: {},
    mixins: [],
    data: function () {
      return {}
    },
    filters: {},
    methods: {},
    created: function () {
    },
    mounted: function () {
    },
    updated: function () {
    },
    destroyed: function () {
    }
  }
</script>

<style scoped>
  .DhCtaComponent {
  }
</style>
